/* The coupon app renders its controls inside a separate widget, sometimes in a shadow root. */
(function () {
  const initialized = new WeakSet();
  const closeSelector = 'a.ocp__modal__link[data-modal-close]';
  function improveWidget(host) {
    if (host.nodeName !== 'ONECLICKPOPUP-WIDGET' || initialized.has(host)) return;
    initialized.add(host);
    const root = host.shadowRoot || host;
    function updateControls() {
      root.querySelectorAll('.primary-action-button').forEach(button => {
        if (button.style.backgroundColor === 'rgb(236, 123, 43)' &&
            getComputedStyle(button).color === 'rgb(255, 255, 255)') {
          button.style.color = '#382b25';
        }
      });
      root.querySelectorAll(closeSelector).forEach(link => {
        if (!/^javascript:/i.test(link.getAttribute('href') || '')) return;
        link.removeAttribute('href');
        link.setAttribute('role', 'button');
        link.tabIndex = 0;
        if (!link.textContent.trim() && !link.hasAttribute('aria-label')) link.setAttribute('aria-label', 'Close offer');
      });
    }
    root.addEventListener('keydown', event => {
      if (event.defaultPrevented || !['Enter', ' '].includes(event.key)) return;
      const control = event.target.closest?.(closeSelector);
      if (control?.getAttribute('role') !== 'button' || control.hasAttribute('href')) return;
      event.preventDefault();
      control.click();
    });
    updateControls();
    new MutationObserver(updateControls).observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['href','style']});
  }
  document.querySelectorAll('oneclickpopup-widget').forEach(improveWidget);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(improveWidget));
  }).observe(document.body, {childList: true});
})();
